import React from 'react';
import { useNavigate } from 'react-router-dom';

const GamesHub: React.FC = () => {
    const navigate = useNavigate();

    const games = [
        {
            id: 'punctuation',
            title: 'Punctuation Panic',
            description: 'Fix missing punctuation',
            icon: '❗',
            color: '#4ECDC4',
            route: '/grammar/detective'
        },
        {
            id: 'grammar',
            title: 'Grammar Invaders',
            description: 'Shoot correct grammar answers',
            icon: '👾',
            color: '#9B86BD',
            route: '/grammar/defender'
        },
        {
            id: 'word-builder',
            title: 'Word Builder',
            description: 'Drag letters to form words',
            icon: '🔤',
            color: '#F5A962',
            route: '/crosswords'
        },
        {
            id: 'typing',
            title: 'Dragon Racing',
            description: 'Type fast to win!',
            icon: '🐉',
            color: '#FFE66D',
            route: '/dragon-racing'
        }
    ];

    return (
        <div style={{
            background: '#f5f5f5',
            minHeight: '100vh',
            padding: '40px',
            fontFamily: "'Inter', sans-serif"
        }}>
            <div style={{
                maxWidth: '1200px',
                margin: '0 auto'
            }}>
                {/* Header */}
                <h1 style={{
                    fontSize: '3rem',
                    fontWeight: '800',
                    color: '#333',
                    margin: '0 0 15px 0',
                    textAlign: 'center'
                }}>
                    Games Hub
                </h1>
                <p style={{
                    fontSize: '1.2rem',
                    color: '#666',
                    textAlign: 'center',
                    margin: '0 0 50px 0'
                }}>
                    Play fun games to practice grammar & vocabulary!
                </p>

                {/* Games Grid */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                    gap: '30px',
                    marginBottom: '40px'
                }}>
                    {games.map(game => (
                        <div
                            key={game.id}
                            onClick={() => navigate(game.route)}
                            style={{
                                background: 'white',
                                borderRadius: '20px',
                                padding: '40px 30px',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                border: '2px solid #e0e0e0',
                                textAlign: 'center'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-8px)';
                                e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.15)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}
                        >
                            <div style={{
                                width: '120px',
                                height: '120px',
                                borderRadius: '20px',
                                background: game.color,
                                margin: '0 auto 25px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '4rem'
                            }}>
                                {game.icon}
                            </div>
                            <h3 style={{
                                fontSize: '1.5rem',
                                fontWeight: '700',
                                color: '#333',
                                margin: '0 0 10px 0'
                            }}>
                                {game.title}
                            </h3>
                            <p style={{
                                fontSize: '1rem',
                                color: '#666',
                                margin: 0
                            }}>
                                {game.description}
                            </p>
                        </div>
                    ))}
                </div>

                {/* XP Card */}
                <div style={{
                    background: '#FFF9E6',
                    borderRadius: '20px',
                    padding: '30px',
                    border: '2px solid #FFE66D',
                    textAlign: 'center'
                }}>
                    <div style={{ fontSize: '3rem', marginBottom: '15px' }}>🎉</div>
                    <h2 style={{
                        fontSize: '1.5rem',
                        fontWeight: '700',
                        margin: '0 0 10px 0'
                    }}>
                        You've earned 120 XP!
                    </h2>
                    <p style={{
                        fontSize: '1rem',
                        color: '#666',
                        margin: 0
                    }}>
                        Keep playing to level up!
                    </p>
                </div>
            </div>
        </div>
    );
};

export default GamesHub;